import React from 'react';
import ReactDOM from 'react-dom';
import SearchBox from './SearchBox';
import SearchList from './SearchList';
import PropTypes from 'prop-types';
import './index.scss';
import enhanceWithClickOutside from 'react-click-outside';
import { connect } from 'react-redux';
import { searchTextInListByListKey } from '../../helpers/Common';

const MAX_SHOW = 20;

class SearchFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowDropDown: false,
      currentSearch: props.currentSearch,
      currentItemActive: -1,
      listFilter: [],
      listSearchPos: {
        left: null,
        top: null,
      },
    };
    this.inputRef = React.createRef();
    this.listSearchRef = {};
    this.parentListSearchRef = React.createRef();
    this.searchListEl = document.createElement('div');
  }

  componentDidMount() {
    const { parentSelector } = this.props;
    if (parentSelector) {
      this.inputRef.current
        .closest(parentSelector)
        .appendChild(this.searchListEl);
      this.table = this.inputRef.current.closest('table').parentNode.parentNode;
      if (this.table) {
        this.table.addEventListener('scroll', this.hideDropDown);
      }
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.currentSearch !== this.props.currentSearch) {
      this.setState({
        currentSearch: nextProps.currentSearch,
        isShowDropDown: false,
        currentItemActive: -1,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { listFilter } = this.state;
    const { parentSelector } = this.props;
    if (listFilter !== prevState.listFilter && parentSelector) {
      this.setState({
        listSearchPos: this.calcListSearchPos(),
      });
    }
  }

  componentWillUnmount() {
    const { parentSelector } = this.props;
    if (parentSelector && this.inputRef.current) {
      this.inputRef.current
        .closest(parentSelector)
        .appendChild(this.searchListEl);
    }

    if (this.table) {
      this.table.removeEventListener('scroll', this.hideDropDown);
    }
  }

  hideDropDown = () => {
    if (this.state.isShowDropDown) {
      this.setState({
        currentItemActive: -1,
        isShowDropDown: false,
        currentSearch: this.props.currentSearch,
      });
    }
  };

  handleClickOutside = () => {
    this.hideDropDown();
  };

  handleChange = textSearch => {
    const { listKeyFilter, listSearch, sortKey } = this.props;
    const listFilter = this.getListFilter(
      listSearch,
      listKeyFilter,
      textSearch,
      sortKey,
    );

    this.setState({
      isShowDropDown: true,
      currentSearch: {
        [sortKey]: textSearch,
      },
      currentItemActive: -1,
      listFilter,
    });
  };

  clickItemSearch = item => {
    const { clickItemSearch, currentSearch, mainKey } = this.props;

    if (currentSearch[mainKey] !== item[mainKey]) {
      clickItemSearch(item);
    } else {
      this.setState({
        currentSearch,
        isShowDropDown: false,
        currentItemActive: -1,
      });
    }
  };

  calcListSearchPos = () => {
    const { parentSelector } = this.props;
    const { top, left, height } = this.inputRef.current.getBoundingClientRect();
    const parentRect = this.inputRef.current
      .closest(parentSelector)
      .getBoundingClientRect();
    const listSearchHeight = this.parentListSearchRef.current.container
      .clientHeight;
    const padding = 10;
    if (
      top + height + listSearchHeight > parentRect.bottom &&
      top - listSearchHeight - padding > parentRect.top
    ) {
      return {
        left,
        top: top - listSearchHeight - padding,
      };
    }
    return {
      left,
      top: top + height,
    };
  };

  clickSearchBox = () => {
    const { listKeyFilter, listSearch, sortKey, mainKey } = this.props;

    const listFilter = this.getListFilter(
      listSearch,
      listKeyFilter,
      '',
      sortKey,
    );

    this.setState({
      isShowDropDown: true,
      currentSearch: {
        [sortKey]: '',
        [mainKey]: '',
      },
      listFilter,
    });
  };

  enterKeyBoard = listFilter => {
    const { currentItemActive } = this.state;

    if (listFilter.length > 0) {
      const index = currentItemActive >= 0 ? currentItemActive : 0;
      this.clickItemSearch(listFilter[index]);
    }
    this.inputRef.current.blur();
  };

  scrollView = listFilter => count => {
    const currentItemActive = this.state.currentItemActive + count;
    if (currentItemActive >= 0 && currentItemActive < listFilter.length) {
      this.parentListSearchRef.current.scrollTop(
        this.listSearchRef[currentItemActive].offsetTop,
      );
      this.setState({ currentItemActive });
    }
  };

  getListFilter = (listSearch, listKeyFilter, textSearch) => {
    const { result: totalListFilter } = searchTextInListByListKey(
      listSearch,
      textSearch,
      listKeyFilter,
    );
    return totalListFilter.filter((item, index) => index < MAX_SHOW);
  };

  renderSearchList = () => {
    const { schema, parentSelector } = this.props;
    const {
      isShowDropDown,
      currentItemActive,
      listFilter,
      listSearchPos,
    } = this.state;

    return (
      <SearchList
        isShow={isShowDropDown}
        listSearchPos={parentSelector ? listSearchPos : null}
        parentListSearchRef={this.parentListSearchRef}
        schema={schema}
        listFilter={listFilter}
        clickItemSearch={this.clickItemSearch}
        listSearchRef={this.listSearchRef}
        currentItemActive={currentItemActive}
      />
    );
  };

  render() {
    const {
      parentSelector,
      sortKey,
      mainKey,
      isShowNameAndIndex,
      customWidth = 230,
    } = this.props;
    const { isShowDropDown, currentSearch, listFilter } = this.state;

    return (
      <div className="search-filter-wrapper" style={{ minWidth: customWidth }}>
        <div className="search-filter">
          <SearchBox
            customWidth={customWidth}
            isShowNameAndIndex={isShowNameAndIndex}
            currentSearch={currentSearch}
            isShowDropDown={isShowDropDown}
            listFilter={listFilter}
            enterKeyBoard={() => this.enterKeyBoard(listFilter)}
            inputRef={this.inputRef}
            textSearch={currentSearch[sortKey]}
            mainSearch={currentSearch[mainKey]}
            handleChange={this.handleChange}
            handleChangeTextSmall={this.handleChangeTextSmall}
            clickSearchBox={this.clickSearchBox}
            scrollView={this.scrollView(listFilter)}
          />
          {parentSelector
            ? ReactDOM.createPortal(this.renderSearchList(), this.searchListEl)
            : this.renderSearchList()}
        </div>
      </div>
    );
  }
}

SearchFilter.propTypes = {
  clickItemSearch: PropTypes.func,
  currentSearch: PropTypes.object,
  getListSearchFromRedux: PropTypes.func,
  listKeyFilter: PropTypes.array,
  schema: PropTypes.array,
  sortKey: PropTypes.string,
  mainKey: PropTypes.string,
  parentSelector: PropTypes.string,
  isShowNameAndIndex: PropTypes.bool,
};

SearchFilter.defaultProps = {
  clickItemSearch: code => {},
  currentSearch: {},
  getListSearchFromRedux: state => {},
  listKeyFilter: [],
  schema: [],
  sortKey: '',
  mainKey: '',
  parentSelector: '',
  isShowNameAndIndex: true,
};

const mapStateToProps = (state, { getListSearchFromRedux }) => {
  return {
    listSearch: getListSearchFromRedux(state),
  };
};

export default connect(mapStateToProps)(enhanceWithClickOutside(SearchFilter));
